import React, { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import BookingTransactions from './BookingTransactions';
import MembershipTransactions from './MembershipTransactions';
import CreditTransfers from './CreditTransfers';

function TransactionsLookup() {
  const [activeTab, setActiveTab] = useState(0);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  const renderTabContent = () => {
    if (activeTab === 0) {
      return <BookingTransactions />;
    }
    if (activeTab === 1) {
      return <MembershipTransactions />;
    }

    return <CreditTransfers />;
  };

  return (
    <>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
        <Tabs
          value={activeTab}
          onChange={handleChange}
          textColor='primary'
          indicatorColor='primary'
          sx={{
            '& .MuiTab-root': {
              fontWeight: 400,
              opacity: 0.7,
            },
            '& .Mui-selected': {
              fontWeight: 600,
              opacity: 1,
              backgroundColor: 'rgba(0, 187, 205, 0.08)',
            },
            '& .MuiTabs-indicator': {
              height: 3,
            },
          }}
        >
          <Tab label='Booking Payments' />
          <Tab label='Membership Payments' />
          <Tab label='Credit Transfers' />
        </Tabs>
      </Box>
      {renderTabContent()}
    </>
  );
}

export default TransactionsLookup;
